import React, { useState } from 'react';
import './PlatformFeatures.css';

const PlatformFeatures = ({ features, onChange }) => {
  // State to track which description tooltip is visible
  const [visibleTooltip, setVisibleTooltip] = useState(null);

  // Toggle tooltip visibility
  const toggleTooltip = (featureId) => {
    setVisibleTooltip(visibleTooltip === featureId ? null : featureId);
  };

  return (
    <div className="platform-features">
      <div className="features-header">
        <h4>Funcționalități incluse:</h4>
      </div>
      <div className="features-list">
        {features.map(feature => (
          <div key={feature.id} className="feature-item">
            <label className="feature-checkbox">
              <input
                type="checkbox"
                checked={feature.enabled}
                onChange={() => onChange(feature.id, !feature.enabled)}
              />
              <span className="feature-label">{feature.label}</span>
              <button 
                type="button" 
                className="info-button"
                onClick={(e) => {
                  e.preventDefault();
                  toggleTooltip(feature.id);
                }}
              >
                <span className="info-icon">?</span>
              </button>
            </label>
            {visibleTooltip === feature.id && (
              <div className="feature-tooltip">
                {feature.description}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlatformFeatures;